import React, { useMemo } from 'react';

const defaultMeta = {
  title: 'Wettkampf',
  location: 'Ort folgt',
  course: '-',
  dateRange: 'Datum folgt',
  status: 'In Planung',
  headOfficial: 'Noch offen',
  contact: 'team@example.org'
};

export function CompetitionOverview({ competitionId, data, meta }) {
  // Daten aus BackendDTO oder Meta-Prop zusammenstellen
  const mergedMeta = useMemo(() => {
    const fromData = data ? {
      title: data.competitionName || 'Wettkampf',
      location: data.city || 'Ort folgt',
      course: data.laneCount ? `${data.laneFirst}-${data.laneFirst + data.laneCount - 1}` : '-',
      contact: data.organizerMail || data.organizerContact || 'team@example.org',
      headOfficial: 'Noch offen',
      status: 'In Planung'
    } : {};

    return {
      ...defaultMeta,
      competitionId,
      ...fromData,
      ...meta
    };
  }, [competitionId, data, meta]);

  const highlightItems = [
    { label: 'Wettkampf', value: mergedMeta.title },
    { label: 'Ort', value: mergedMeta.location },
    { label: 'Bahn', value: mergedMeta.course },
    { label: 'Zeitraum', value: mergedMeta.dateRange },
    { label: 'Status', value: mergedMeta.status },
    { label: 'Leitung', value: mergedMeta.headOfficial },
    { label: 'Kontakt', value: mergedMeta.contact },
    { label: 'ID', value: mergedMeta.competitionId || 'unbekannt' }
  ];

  return (
    <div className='competition-section competition-overview'>
      <div className='section-header'>
        <div>
          <div className='section-title'>Allgemeines</div>
          <div className='section-subtitle'>Rahmendaten zum Wettkampf</div>
        </div>
        <div className='section-pill'>Intern · nicht öffentlich</div>
      </div>

      <div className='summary-grid'>
        {highlightItems.map(item => (
          <div key={item.label} className='summary-card'>
            <div className='summary-label'>{item.label}</div>
            <div className='summary-value'>{item.value}</div>
          </div>
        ))}
      </div>

      <div className='details-block'>
        <div className='details-title'>Beschreibung</div>
        <p className='details-text'>
          {data?.detail || 'Hinterlege hier Ausschreibung, Kontaktwege oder Besonderheiten des Veranstalters. Die Inhalte sind nur für angemeldete Nutzer sichtbar.'}
        </p>
      </div>
    </div>
  );
}
